import {textType} from 'shared/mirrors/text'

export const main: textType['main'] = {
  siteName: 'GoChatty',
  supportMail: 'support@gochatty.com',
  canadaAddress: 'INFORA LIMITED, 45b West Wilmot Street, 201, Richmond Hill, Ontario, Canada, L4B 2P3',
  estoniaAddress: 'Entertechia OÜ, Harju maakond, Tallinn, Lasnamäe linnaosa, Peterburi tee 53, 11415',
  ukAddress: 'NETTERO LIMITED, Suite 23021 8 Shepherd Market, Mayfair, London, United Kingdom, W1J 7JY',
  gibraltarAddress: 'Infora Limited, SUITE 4.3.02, BLOCK 4 EUROTOWERS GIBRALTAR, GX11 1AA, GIBRALTAR',
}